// extracted by mini-css-extract-plugin
export var dark = "v_sY";
export var darkcookie = "v_sZ";
export var tintedcookie = "v_s0";
export var regularcookie = "v_s1";
export var darkbase = "v_s2";
export var tintedbase = "v_s3";
export var regularbase = "v_s4";
export var darkraw = "v_s5";
export var tintedraw = "v_s6";
export var regularraw = "v_s7";
export var darkchick = "v_s8";
export var tintedchick = "v_s9";
export var regularchick = "v_tb";
export var darkherbarium = "v_tc";
export var tintedherbarium = "v_td";
export var regularherbarium = "v_tf";
export var darkholiday = "v_tg";
export var tintedholiday = "v_th";
export var regularholiday = "v_tj";
export var darkoffline = "v_tk";
export var tintedoffline = "v_tl";
export var regularoffline = "v_tm";
export var darkorchid = "v_tn";
export var tintedorchid = "v_tp";
export var regularorchid = "v_tq";
export var darkpro = "v_tr";
export var tintedpro = "v_ts";
export var regularpro = "v_tt";
export var darkrose = "v_tv";
export var tintedrose = "v_tw";
export var regularrose = "v_tx";
export var darktimes = "v_ty";
export var tintedtimes = "v_tz";
export var regulartimes = "v_tB";
export var darkwagon = "v_tC";
export var tintedwagon = "v_tD";
export var regularwagon = "v_tF";